export const styles = {
  root: {
    width: 70,
    height: 70,
  },
}
